var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('InventoryItemIndexTableFilter',{on:{"filter":_vm.filterItems}}),_c('TaskInputItemEditFormTable',{ref:"table",attrs:{"task-id":_vm.taskId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }